var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "container is-fluid" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "columns is-multiline" },
          [
            _c("div", { staticClass: "column is-9" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.isCreating = true
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "plus", size: "is-small" },
                      }),
                      _c("span", [_vm._v(" Add user")]),
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-info",
                      on: {
                        click: function ($event) {
                          _vm.isActivatingUser = true
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "rotate", size: "is-small" },
                      }),
                      _c("span", [_vm._v(" Activate user")]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("ag-grid-vue", {
              staticClass: "ag-theme-alpine",
              staticStyle: { width: "100%", height: "1000px" },
              attrs: {
                "row-data": _vm.users,
                "grid-options": _vm.gridOptions,
                pagination: true,
                "pagination-page-size": 20,
                "multi-sort-key": "ctrl",
                modules: _vm.modules,
                "row-selection": "single",
              },
              on: { "grid-ready": _vm.gridReady },
            }),
          ],
          1
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreating,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreating = $event
            },
          },
        },
        [
          _c("UserForm", {
            attrs: {
              groups: _vm.groups,
              "is-submitting": _vm.isSubmitting,
              roles: _vm.roles,
            },
            on: { submit: _vm.submitCreateUser },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditing,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditing = $event
            },
          },
        },
        [
          _c("UserForm", {
            attrs: {
              groups: _vm.groups,
              "editable-user": _vm.editableUser,
              "is-submitting": _vm.isSubmitting,
              roles: _vm.roles,
            },
            on: { submit: _vm.submitUpdateUser },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.isActivatingUser, "has-modal-card": "" },
          on: {
            "update:active": function ($event) {
              _vm.isActivatingUser = $event
            },
          },
        },
        [_c("ActiveUserForm", { on: { "on-close": _vm.close } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-multiline" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c("h1", { staticClass: "title" }, [_vm._v(" Users ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }